import React, { useState, useMemo } from 'react';

export interface ThumbtackProps {
  className?: string;
  style?: React.CSSProperties;
  size?: string;
  pinIndex?: number;
}

const LOCAL_THUMBTACK = '/Images/Letters on Paper/thumbtack.png';
const FALLBACK_THUMBTACK = 'https://placehold.co/40x40/png?text=thumbtack+pin';

export const Thumbtack: React.FC<ThumbtackProps> = ({
  className = '',
  style = {},
  size,
  pinIndex
}) => {
  const [src, setSrc] = useState(LOCAL_THUMBTACK);

  // Random HSV shift: +/- 2% Hue, +/- 4% Value (Brightness), +/- 8% Saturation
  const hsvFilter = useMemo(() => {
    const seed = typeof pinIndex === 'number'
      ? Math.sin(pinIndex * 133.7 + 42.1) * 10000
      : Math.random();
    const r1 = Math.abs(seed) % 1;
    const r2 = Math.abs(Math.sin((seed + 1.3) * 311.9)) % 1;
    const r3 = Math.abs(Math.cos((seed + 2.7) * 523.1)) % 1;

    // Hue: +/- 2% of 360deg = +/- 7.2deg
    const hueShift = +((r1 * 4 - 2) * 3.6).toFixed(1);
    // Saturation: 100% +/- 8% = [92%, 108%]
    const satShift = +(100 + (r2 * 16 - 8)).toFixed(1);
    // Value (Brightness): 100% +/- 4% = [96%, 104%]
    const valShift = +(100 + (r3 * 8 - 4)).toFixed(1);

    return `hue-rotate(${hueShift}deg) saturate(${satShift}%) brightness(${valShift}%)`;
  }, [pinIndex]);

  return (
    <img
      src={src}
      alt="thumbtack pin"
      className={`thumbtack ${className}`}
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        height: 'auto',
        zIndex: 10,
        pointerEvents: 'none',
        userSelect: 'none',
        filter: `${hsvFilter} drop-shadow(0 3px 5px rgba(0, 0, 0, 0.6))`,
        ...(size ? { width: size, top: '-20px' } : {}),
        ...style
      }}
      onError={() => {
        if (src === LOCAL_THUMBTACK) {
          setSrc('Images/Letters on Paper/thumbtack.png');
        } else if (src !== FALLBACK_THUMBTACK) {
          setSrc(FALLBACK_THUMBTACK);
        }
      }}
    />
  );
};

export default Thumbtack;
